<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="sim-images" fxLayout="row" fxLayoutAlign="space-around center">
  <div fxFlex="60">
    <img
      class="image"
      [src]="images[0].images"
      *ngIf="images[0]"
      (click)="favouriteClicked(0)"
      alt="img1"
    />
  </div>
  <div fxFlex="36">
    <img
      class="image"
      [src]="images[1].images"
      *ngIf="images[1]"
      (click)="favouriteClicked(1)"
      alt="img2"
    />
    <img
      class="image"
      [src]="images[2].images"
      *ngIf="images[2]"
      (click)="favouriteClicked(2)"
      alt="img3"
    />
  </div>
</div>
